import DiffMatchPatch from 'diff-match-patch'
import { kuiperClassNames } from '../../utils'

const matchAllNewlines = /\r?\n/g

const injectBreakOnNewlineSplit = (prior, strFragment, isLast, key) => {
  let additions = [strFragment]
  if (!isLast) {
    additions = additions.concat([
      <br key={`${key}:br`} />,
      <br key={`${key}:br2`} />,
    ])
  }
  return prior.concat(additions)
}

const convertNewlinesToBreaks = (string, key) => {
  if (!string) {
    return string
  }

  if (string.match(matchAllNewlines)) {
    const lines = string.split(matchAllNewlines)

    return lines.reduce((prior, strFragment, idx, array) => {
      const isLast = idx === array.length - 1
      return injectBreakOnNewlineSplit(
        prior,
        strFragment,
        isLast,
        `${key}:${idx}`
      )
    }, [])
  }
  return string
}

const wrapAs = (classname, string, key) => (
  <span key={key} className={classname}>
    {convertNewlinesToBreaks(string, key)}
  </span>
)

const wrapAsAdded = wrapAs.bind(null, kuiperClassNames('diff-add'))

const wrapAsRemoved = wrapAs.bind(null, kuiperClassNames('diff-remove'))

const wrapAsNoChange = wrapAs.bind(null, undefined)

export const hydrate = (diff) =>
  diff.map((diffStep, idx) => {
    const action = diffStep[0]
    const value = diffStep[1]
    if (action === 1) {
      // Insertion
      return wrapAsAdded(value, idx)
    }
    if (action === -1) {
      // Deletion
      return wrapAsRemoved(value, idx)
    }
    return wrapAsNoChange(value, idx)
  })

export const diff = (oldText, newText) => {
  const dmp = new DiffMatchPatch()
  const diffs = dmp.diff_main(oldText, newText)
  dmp.diff_cleanupSemantic(diffs)
  return diffs
}
